// extracted by mini-css-extract-plugin
export default {"header":"styles_header__oPXPF","actions":"styles_actions__IY20K","avatar":"styles_avatar__JwNVo"};